// Dersler listesinde sayfalar arası ders seçimi. Seçim sessionStorage'da tutulur.
const STORAGE_KEY = 'courseSelection'

const load = () => {
  try {
    return new Set(JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '[]'))
  } catch (_) {
    return new Set()
  }
}

const save = (ids) => {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(ids)))
  } catch (_) { /* depolama kullanılamıyorsa seçim sadece bu sayfada geçerli olur */ }
}

export function initCourseSelection () {
  const root = document.getElementById('course-selection')
  if (!root) return

  const ids = load()
  const checkboxes = Array.from(document.querySelectorAll('.course-select'))
  const pageToggle = document.getElementById('course-select-page')
  const count = document.getElementById('course-selection-count')
  const button = document.getElementById('course-export-button')
  const form = document.getElementById('course-export-form')
  const hidden = document.getElementById('course-export-ids')

  const render = () => {
    checkboxes.forEach(cb => { cb.checked = ids.has(cb.value) })
    pageToggle.checked = checkboxes.length > 0 && checkboxes.every(cb => cb.checked)
    count.textContent = ids.size
    button.disabled = ids.size === 0
    save(ids)
  }

  checkboxes.forEach(cb => cb.addEventListener('change', () => {
    cb.checked ? ids.add(cb.value) : ids.delete(cb.value)
    render()
  }))

  pageToggle.addEventListener('change', () => {
    checkboxes.forEach(cb => pageToggle.checked ? ids.add(cb.value) : ids.delete(cb.value))
    render()
  })

  document.getElementById('course-selection-clear').addEventListener('click', (e) => {
    e.preventDefault()
    ids.clear()
    render()
  })

  document.getElementById('course-select-all-results').addEventListener('click', (e) => {
    e.preventDefault()
    fetch(root.dataset.idsUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(response => response.json())
      .then(list => { list.forEach(id => ids.add(String(id))); render() })
  })

  // Seçili tüm ders id'leri (diğer sayfalardakiler dahil) forma eklenir
  form.addEventListener('submit', () => {
    hidden.innerHTML = ''
    ids.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'course_ids[]'
      input.value = id
      hidden.appendChild(input)
    })
  })

  render()
}
